var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "form__group" },
    [
      _c(
        "multiselect",
        {
          class: {
            form__control: true,
            "form__control--invalid": _vm.errors.first(this.name),
          },
          attrs: {
            options: _vm.results,
            placeholder: _vm.placeholder,
            "allow-empty": _vm.allowEmpty,
            label: "name",
            "track-by": "id",
            searchable: true,
            loading: _vm.loading,
            "internal-search": false,
            multiple: _vm.multiple,
            "options-limit": 10,
            "show-labels": false,
          },
          on: { "search-change": _vm.onSearchChange },
          scopedSlots: _vm._u([
            {
              key: "selection",
              fn: function () {
                return [
                  _vm.selected && _vm.selected.length > 0
                    ? _c("span", { staticClass: "multiselect__placeholder" }, [
                        _vm._v("Select a user..."),
                      ])
                    : _vm._e(),
                ]
              },
              proxy: true,
            },
            {
              key: "singleLabel",
              fn: function () {
                return [
                  _vm.selected
                    ? _c("span", { staticClass: "multiselect__placeholder" }, [
                        _vm._v("Select a user..."),
                      ])
                    : _vm._e(),
                ]
              },
              proxy: true,
            },
          ]),
          model: {
            value: _vm.selected,
            callback: function ($$v) {
              _vm.selected = $$v
            },
            expression: "selected",
          },
        },
        [
          _c("span", { attrs: { slot: "noOptions" }, slot: "noOptions" }, [
            _vm._v("Type a name to search users..."),
          ]),
        ]
      ),
      _vm._v(" "),
      _vm.multiple && _vm.selected.length > 0
        ? _vm._l(_vm.selected, function (user, index) {
            return _vm.selected
              ? _c("div", { key: user.id, staticClass: "selected" }, [
                  user && user.avatar && user.id
                    ? _c("img", {
                        staticClass: "selected__avatar avatar avatar--small",
                        attrs: { src: `/images/avatar/${user.id}`, alt: "" },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  user ? _c("span", [_vm._v(_vm._s(user.name))]) : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "selected__remove",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.selected.splice(index, 1)
                        },
                      },
                    },
                    [_c("SvgIcon", { attrs: { icon: "x" } })],
                    1
                  ),
                ])
              : _vm._e()
          })
        : [
            _vm.selected
              ? _c("div", { staticClass: "selected" }, [
                  _vm.selected.avatar
                    ? _c("img", {
                        staticClass: "selected__avatar avatar avatar--small",
                        attrs: {
                          src: `/images/avatar/${_vm.selected.id}`,
                          alt: "",
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.selected.name))]),
                ])
              : _vm._e(),
          ],
      _vm._v(" "),
      _c("label", { staticClass: "form__label" }, [_vm._v(_vm._s(_vm.label))]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "form__validation",
          attrs: { slot: "validation" },
          slot: "validation",
        },
        [_vm._v(_vm._s(_vm.errors.first(this.name)))]
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }